import { AlertController, ToastController } from '@ionic/angular';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class AlertService {
  alert: HTMLIonAlertElement;
  constructor(
    private alertCtrl: AlertController,
    public toastCtrl: ToastController
  ) {}

  async presentAlert({ header, message, buttons }) {
    this.alert = await this.alertCtrl.create({
      header,
      message,
      buttons,
    });
    await this.alert.present();
  }

  dismissAlert() {
    this.alert.dismiss();
  }

  async presentAlertWithConfirm({ header, message, ok, cancel }) {
    this.alert = await this.alertCtrl.create({
      header,
      message,
      buttons: [
        {
          text: cancel,
          role: 'cancel',
        },
        {
          text: ok,
          handler: () => {
            return true;
          },
        },
      ],
    });

    await this.alert.present();
    return alert;
  }

  async presentToast({ color, message }) {
    const toast = await this.toastCtrl.create({
      message,
      duration: 2000,
      animated: true,
      color,
    });

    return await toast.present();
  }
}
